import { FIELD_TYPE, INS_TYPE_COMPREHENSIVE, WITHOUT_RULE_ENGINE } from "@src/config/constant"
import dateFormat from "dateformat";


export const callServiceToCreateLead = (sectionList: any, params?: any) => {
    let param = {} as any
    // eslint-disable-next-line  
    sectionList?.map((sectionItem: any) => {
        let blockList = sectionItem['blocks'] as []
        // eslint-disable-next-line
        blockList.map((blockItem: any) => {
            // eslint-disable-next-line
            blockItem?.fields?.map((item: any) => {
                if (item.name === 'vehicle') { }
                else if (isShowDynamicField(item, blockList)) {
                    if (item.type === 'date' || item.type === 'future_date') {
                        if (item?.value) {
                            param[item.name] = dateFormat(item.value, 'yyyy-mm-dd')
                        }
                    }
                    else if (typeof item.value === 'object') {
                        if (item.type === "mdd") {
                            param['other_doc'] = item.value.map((val: any) => val.value);
                        }

                        else if (item.name === 'vehicle_classification' && item?.value?.value) {
                            param['vehicle_type'] = item?.value?.value
                            param['vehicle_usage'] = item?.value?.vehicle_usage
                        }
                        else if (item?.value?.value) {
                            // Checking if user has saved value or not
                            if (item.data_type === 'number') {
                                param[item.name] = item?.value?.value ? parseFloat(item?.value?.value) : item?.value?.value
                            }
                            else {
                                param[item.name] = item?.value?.value?.toString()
                            }
                            item.error = ''
                        }
                    }
                    else {
                        if (item.name === "") { }
                        else if (item?.value) {
                            if (item.data_type === 'number') {
                                param[item.name] = item?.value ? parseFloat(item?.value) : item?.value
                                item.error = ''
                            }
                            else if (item?.value) {
                                param[item.name] = item?.value?.toString()
                                item.error = ''
                            }
                        }
                    }
                } else if (item.name === 'commercial_type'){
                    param[item.name] = item?.value?.value;
                }
            })
        })
    })
    return param;
}

export const isShowDynamicField = (detail: any, blocklist: any, params?: any) => {
    if (detail?.field_show) {
        //if editing quote detail page && apptype is agency
        //then hide financing to/from date
        // if (['finance_from_date', 'finance_to_date', 'insurer_name', 'financier', 'expiration_date'].includes(detail.name)) {
        //     return false
        // }
        const splitType = detail?.field_show?.split('/')        

         if(splitType[0] === 'vehicle_usage'){
                const vehicleUsage = detail.vehicle_classification?.value?.vehicle_usage;                
                if(splitType[1] == vehicleUsage){
                    return true;
                }                
        }

        if (splitType?.length > 1) {
            const expectedValues = splitType[1].includes('@') ? splitType[1].split('@') : [splitType[1]];
            let fieldList = (blocklist?.[0]?.['fields']) ? blocklist[0]['fields'] : [];
            const filterFieldItem: any = fieldList.filter((ob: any) => ob.name === splitType[0])?.[0];

            let value = String(filterFieldItem?.value?.value)

            //making sure that value is not "" && splitType is not 0
            if (!['', undefined].includes(value) && expectedValues.includes(value)) {
                return true;
            }
            else return false
        }
    }

    return !!detail?.['is_show']
}

export const getAddonList = (item: any, filterList?: any, ruleEngine?: any) => {

    let addonParamList: object[] = []
    let filterAddon = item?.original_list?.filter((addonItem: any) => addonItem.is_selected)

    filterAddon = (filterList) ? filterList.filter((addonItem: any) => addonItem.is_selected) : filterAddon

    if (filterAddon?.length) {
        filterAddon?.forEach((item: any) => {
            let addOnParam: { [key: string]: any } = {};
            addOnParam['id'] = item.id
            if (item.coverage_amt) {
                addOnParam['coverage_amount'] = item.coverage_amt
                let optionItem = item?.coverage_list?.filter((optionItem: any) => optionItem?.value === item.coverage_amt)?.[0]
                if (optionItem && item.type !== 'pa') {
                    addOnParam['premium_amount'] = (ruleEngine && ruleEngine === WITHOUT_RULE_ENGINE) ? '' : parseFloat(optionItem.premium_amount || '0')

                } else if (optionItem && item.type === 'pa') {

                    addOnParam['seat_capacity'] = (item.seat_capacity) ? item.seat_capacity : ''
                    if (ruleEngine && ruleEngine === WITHOUT_RULE_ENGINE) {
                        addOnParam['premium_amount'] = (item.premium_amount) ? parseFloat(item.premium_amount || '0') : ''
                    }
                    if (item.extra_seat_value) {
                        addOnParam['extra_seat_capacity'] = item.extra_seat_value
                    }
                }
            }
            if (item.premium_amount) {
                addOnParam['premium_amount'] = parseFloat(item.premium_amount || '0')
            }
            if (item.aon_rate) {
                addOnParam['aon_rate'] = item.aon_rate
            }
            if (item.is_editable) {
                addOnParam['is_editable'] = item.is_editable
            }
            if (item.milestone_coverage_amount_limit) {
                addOnParam['milestone_coverage_amount_limit'] = item.milestone_coverage_amount_limit
            }
            if (item.oona_coverage_amount_limit) {
                addOnParam['oona_coverage_amount_limit'] = item.oona_coverage_amount_limit
                addOnParam['oona_seat_capacity_limit'] = item.oona_seat_capacity_limit
            }


            addonParamList.push(addOnParam)
        })
    }

    return addonParamList
}


export const autoFillData = async (data: any, sectionItem: any, clear?: boolean) => {
    const autofillParams = { ...data }

    // Select Vehicle (MMV) is stored as a display string; build it from saved MMV names
    if (!clear && !autofillParams.vehicle) {
        const mmvLabel = [
            autofillParams.make_name,
            autofillParams.model_name,
            autofillParams.version_name
        ].filter(Boolean).join(' ').trim()
        if (mmvLabel) {
            autofillParams.vehicle = mmvLabel
        }
    }

    // Lead APIs often return vehicle_type; form field is vehicle_classification
    if (!clear && autofillParams.vehicle_type != null && autofillParams.vehicle_classification == null) {
        autofillParams.vehicle_classification = autofillParams.vehicle_type
    }

    // Lead details may expose insurance_type_id
    if (!clear && autofillParams.insurance_type == null && autofillParams.insurance_type_id != null) {
        autofillParams.insurance_type = autofillParams.insurance_type_id
    }

    // Lead details may expose commercial_type_id
    if (!clear && autofillParams.commercial_type == null && autofillParams.commercial_type_id != null) {
        autofillParams.commercial_type = autofillParams.commercial_type_id
    }

    // Lead seat alias + address aliases used by agency form / createAgencyLead
    if (!clear && autofillParams.seat_capacity == null && autofillParams.vehicle_seat != null) {
        autofillParams.seat_capacity = autofillParams.vehicle_seat
    }
    if (!clear && !autofillParams.address) {
        autofillParams.address = autofillParams.cur_full_address || autofillParams.per_full_address
    }
    if (!clear && autofillParams.make_year == null && autofillParams.mfg_year != null) {
        autofillParams.make_year = autofillParams.mfg_year
    }
    if (!clear && autofillParams.car_fmv == null && (autofillParams.fmv_car != null || autofillParams.total_fmv != null)) {
        autofillParams.car_fmv = autofillParams.fmv_car ?? autofillParams.total_fmv
    }
    if (!clear && autofillParams.plate_number == null && autofillParams.plate_no != null) {
        autofillParams.plate_number = autofillParams.plate_no
    }
    if (!clear && autofillParams.car_under_finance == null && autofillParams.is_under_financing != null) {
        autofillParams.car_under_finance = autofillParams.is_under_financing
    }
    if (!clear && !autofillParams.name && autofillParams.customer_name) {
        autofillParams.name = autofillParams.customer_name
    }

    const updatedSectionList: any = await updateInsuranceForm(autofillParams, [...JSON.parse(JSON.stringify(sectionItem?.blocks?.[0]?.fields)), ...JSON.parse(JSON.stringify(sectionItem?.blocks?.[1]?.fields))], clear)
    let updatedList = sectionItem?.blocks?.map((item: any) => {
        let updatedItem = { ...item }

        let updatedFields = item?.fields?.map((field: any) => {
            let newField = { ...field }
            let itemInList = updatedSectionList?.find((e: any) => e.name === field.name)
            if (itemInList) {
                newField = itemInList
            }
            return newField
        })

        updatedItem['fields'] = updatedFields
        return updatedItem
    })

    let updatedSectionItem = JSON.parse(JSON.stringify(sectionItem))
    updatedSectionItem['blocks'] = updatedList

    return updatedSectionItem
}


export const updateInsuranceForm = (params: any, sectionItem: Array<any>, clear?: boolean, additionalParams?: any) => {
    let keysToModify = ['make', 'seat_capacity', 'fuel_type', 'make_year', 'car_under_finance', 'vehicle_classification', 'vehicle_type', 'vehicle_usage', 'tenure', 'classification_id', 'commercial_type', 'insurance_type']

    for (let key in params) {
        if (keysToModify.includes(key)) {
            const existing = params[key]
            // Keep already-normalized option objects as-is
            if (typeof existing === 'object' && existing !== null && existing.value !== undefined) {
                continue
            }
            let value = existing
            if (['seat_capacity', 'make_year', 'classification_id', 'commercial_type', 'insurance_type', 'vehicle_classification', 'vehicle_type'].includes(key)) {
                value = value !== '' && value != null ? +value : value
            }
            params[key] = { label: value, value: value }
        }
    }
    return new Promise((resolve, reject) => {
        if (clear) sectionItem?.forEach((key: any) => {
            if (key.type !== 'static_info') key.value = ""
        })
        else {
            sectionItem.forEach((ele: any) => {
                if (params?.[ele?.name] !== undefined && params?.[ele?.name] !== null && params?.[ele?.name] !== '') {
                    if (!ele?.value || ele?.name === 'fuel_type') {
                        ele.value = params[ele.name]

                        //handling spelling changes in fuel type
                        if (ele?.name === 'fuel_type') {
                            let findValueInOptions = ele?.options?.find((e: any) => e?.value?.toLowerCase() === (params[ele.name]?.value)?.toLowerCase())
                            if (findValueInOptions) ele.value = findValueInOptions
                        }
                        if (ele.name === "vehicle_classification") {
                            let findValueInOptions = ele?.options?.find((data: any) =>
                                +data.value === +params?.[ele?.name]?.value
                            );
                            if (findValueInOptions) ele.value = findValueInOptions
                        }
                        if (['classification_id', 'commercial_type', 'insurance_type'].includes(ele.name)) {
                            const rawValue = typeof params[ele.name] === 'object' ? params[ele.name]?.value : params[ele.name]
                            const findValueInOptions = ele?.options?.find((data: any) => +data.value === +rawValue)
                            if (findValueInOptions) {
                                ele.value = findValueInOptions
                            } else if (rawValue !== undefined && rawValue !== null && rawValue !== '') {
                                ele.value = { label: String(rawValue), value: +rawValue }
                            }
                        }
                    } else {
                        //data already filled case
                        if (ele.type !== FIELD_TYPE.TEXT_BOX) {
                            let newValue = params[ele.name].label
                            let oldValue = ele.value.label

                            newValue = typeof newValue === 'string' ? newValue.toLowerCase() : newValue
                            oldValue = typeof oldValue === 'string' ? oldValue.toLowerCase() : oldValue

                            //case when old data & new data are not same
                            //then reset child dependencies
                            if (newValue !== oldValue) {
                                let newValueOptions: Array<any> = additionalParams?.[ele?.name] || []
                                if (ele.name === 'make_year') {
                                    let { insurance_type, rule_engine } = additionalParams
                                    let keyName = ele.name

                                    if (rule_engine === WITHOUT_RULE_ENGINE) {
                                        keyName = 'without_mfg_comprehensive'
                                    } else if (insurance_type === INS_TYPE_COMPREHENSIVE) {
                                        keyName = 'mgf_comprehensive'
                                    } else {
                                        keyName = 'mgf_ctpl'
                                    }

                                    newValueOptions = additionalParams?.['make_year']?.[keyName] || []
                                }

                                if (newValueOptions?.length) {
                                    let findDataInOption = newValueOptions.find((el: any) => (typeof el.label === 'string' ? el.label.toLowerCase() : el.label) === newValue)
                                    if (findDataInOption) ele.value = findDataInOption
                                    else ele.value = ""
                                }

                                //reset child dependency
                                let childDependency: Array<any> = ele?.child_depedencies || []
                                if (['seat_capacity', 'make_year'].includes(ele.name)) childDependency.push('insurance_type')

                                if (childDependency?.length) {
                                    sectionItem?.forEach((item: any) => {
                                        // Skip locked fields (e.g. insurance_type disabled in Edit Application)
                                        if (childDependency.includes(item.name) && item.is_enable !== false) {
                                            item.value = ""
                                        }
                                    })
                                }
                            }
                        } else ele.value = params[ele.name]
                    }
                }
            })
        }
        return resolve(sectionItem)
    })
}